import React, {useState} from 'react';

import Modal from 'ui-library/modals/Modal';
import {Tab, TabContainer} from 'ui-library/TabContainer';

import {BasicsTab} from './BasicsTab';
import {ComponentsTab} from './ComponentsTab';
import {ExamplesTab} from './ExamplesTab';
import {HelpGuideTab} from './shared';

export interface VeritasHelpGuideModalProps {
  onRequestClose: () => void;
}

export function VeritasHelpGuideModal({onRequestClose}: VeritasHelpGuideModalProps): JSX.Element {
  const [activeTab, setActiveTab] = useState<HelpGuideTab>(HelpGuideTab.BASICS);

  return (
    <Modal
      title="VERITAS help guide"
      onRequestClose={onRequestClose}
      closeable={true}
      mediumLarge={true}
      enableRedesign={true}
      buttons={[
        {
          text: 'Close',
          cancel: true,
        },
      ]}
      dataTestAttrs={{component: 'VeritasHelpGuideModal', element: 'root'}}
    >
      <TabContainer<HelpGuideTab>
        activeTab={activeTab}
        onRequestTabChange={setActiveTab}
        centerNavItem={true}
      >
        <Tab tabKey={HelpGuideTab.BASICS} title="BASICS">
          <BasicsTab />
        </Tab>
        <Tab tabKey={HelpGuideTab.COMPONENTS} title="COMPONENTS">
          <ComponentsTab />
        </Tab>
        <Tab tabKey={HelpGuideTab.EXAMPLES} title="EXAMPLES">
          <ExamplesTab />
        </Tab>
      </TabContainer>
    </Modal>
  );
}
